import React, { useState } from "react";
import TextInput from "../../../../components/TextInput";
import { toast } from "../../../../components/toastNotification";
import Button from "../../../../components/Button";
import { CheckCircleIcon, XCircleIcon } from "@heroicons/react/24/solid";
import ConfirmBoxModal from "../../../../components/ConfirmBoxModal";
import useAddEmployeeType from "./hooks/useAddEmployeeType";
import useEmployeeType from "./hooks/useEmployeeType";
import { useRecoilState, useRecoilValue } from "recoil";
import { accountAtom } from "../../../Login/atoms/AccountAtom";
import MaterialExTable from "../../../../components/tables/MaterialExTable";

import { addStateEmployeeType, setFilterTextEmployeeType } from "./atoms/atoms";

import CheckBoxHookForm from "components/CheckBoxHookForm";

const EmployeeTypeForm = () => {
  //Hooks
  const AddEmployeeType = useAddEmployeeType();
  const { data } = useEmployeeType();
  //Recoils Call
  const [actionAddState, setActionAddState] =
    useRecoilState(addStateEmployeeType);
  const [_, setFilterText] = useRecoilState(setFilterTextEmployeeType);
  const [changed, setChanged] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [hasEmployeeType, setHasEmployeeType] = useState(false);
  const defaulValues = {
    employeeTypeId: 0,
    employeeTypeName: "",
    createdBy: "",
    createdOn: null,
    updatedBy: null,
    updatedOn: null,
    isActive: 0,
    usedInMexico: 0,
  };
  const [emptypeNewData] = useState([defaulValues]);
  const [employeeTypeExist, setemployeeTypeExist] = useState(false);

  const handleAddEmployeeType = (SourceType, fieldName, inputValue, rowData) => {
    if (SourceType !== "addEmployeeType") return;

    setChanged(true);
    setemployeeTypeExist(false);

    if (fieldName === "employeeTypeName") {
      const trimmedInput = inputValue.trim().toUpperCase();
      const nameMatch = data.find(
        (item) =>
          item.employeeTypeName?.toUpperCase() === trimmedInput &&
          item.usedInMexico === rowData?.usedInMexico
      );

      if (nameMatch) {
        setemployeeTypeExist(true);
      } else {
        emptypeNewData.forEach((x) => {
          x.employeeTypeName = inputValue.trim();
        });
      }

      setHasEmployeeType(trimmedInput !== "");
    }

    if (fieldName === "employeeTypeIsMexico") {
      const existingEntry = data.find(
        (item) =>
          item.employeeTypeName?.toUpperCase() ===
          rowData?.employeeTypeName?.trim().toUpperCase() &&
          item.usedInMexico === inputValue
      );

      if (existingEntry) {
        setemployeeTypeExist(true);
      }

      emptypeNewData.forEach((x) => {
        x.usedInMexico = inputValue;
      });
    }
  };

  //save changes
  const handleSave = (emptypeNewData) => {
    if (changed) {
      if (!employeeTypeExist) {
        if (emptypeNewData.filter((x) => x.employeeTypeName) !== "") {
          //call Insert
          AddEmployeeType(emptypeNewData);
          setActionAddState(!actionAddState);
          setOpenModal(false);
        } else {
          toast.fire(
            "Saving Failed",
            "All required fields must be filled!",
            "error"
          );
          setOpenModal(false);
        }
      } else {
        toast.fire("Saving Failed", "Employee Type already exists!", "error");
        setOpenModal(false);
      }
    } else {
      toast.fire("Saving Failed", "No Changes have been made", "warning");
      setOpenModal(false);
    }
  };
  // end of saving changes

  const matcolumns = [
    {
      title: "Employee Type Name",
      field: "employeeTypeName",
      render: (rowData) => {
        return (
          <div className="grid-cols-2 grid ">
            <TextInput
              defaultValue={rowData.employeeTypeName}
              onChange={(e) => {
                handleAddEmployeeType(
                  "addEmployeeType",
                  "employeeTypeName",
                  e.target.value.trim(),
                  rowData
                );

                e.target.value = e.target.value.replace(/\s+/g, " ");
              }}
            />
          </div>
        );
      },
    },
    {
      title: "Is Mexico",
      render: (rowData) => {
        return (
          <CheckBoxHookForm
            checked={rowData.usedInMexico === true ? true : false}
            onClick={(e) => {
              handleAddEmployeeType(
                "addEmployeeType",
                "employeeTypeIsMexico",
                !rowData.usedInMexico,
                rowData
              )
            }}
            register={() => { }}
          />
        )
      }
    }
  ];
  return (
    <div className="">
      <div className="w-full ">
        <ConfirmBoxModal
          ModalTitle="Add Employee Type"
          qConfirmation=" Are you sure you want to add this?"
          isOpen={openModal}
          onClose={() => setOpenModal(false)}
          onClickFunction={() => {
            handleSave(emptypeNewData);
          }}
        />
        <div className=" px-3 border-l-2  border-primary box-shadow">
          <div className="flex items-center justify-between">
            <div className="text-base text-primary font-bold">
              Add New Employee Type
            </div>
            <div className="flex items-center space-x-1 pt-2 pb-2">
              <Button
                className={`flex items-center shadow-md text-xs font-semibold text-white justify-left gap-x-1 rounded-full bg-senary hover:bg-senary px-3 py-1 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-senary focus:ring-opacity-70
              ${!hasEmployeeType ? "opacity-50" : "opactiy-100"}`}
                disabled={!hasEmployeeType}
                onClickFunction={() => setOpenModal(true)}
              >
                <CheckCircleIcon className="h-4 w-4" />
                <div className="text-xs3 font-normal self-center -mt-px">
                  Save
                </div>
              </Button>
              <Button
                className="flex items-center text-xs shadow-md font-semibold text-white justify-left gap-x-1 rounded-full bg-octonary hover:bg-octonary px-2 py-1 "
                onClickFunction={() => {
                  setActionAddState(!actionAddState);
                  setFilterText("");
                }}
              >
                <XCircleIcon className="h-4 w-4" />
                <div className="text-xs3 font-normal self-center -mt-px">
                  Cancel
                </div>
              </Button>
            </div>
          </div>

          <div className=" h-0.5 w-full border-b-2 border-secondary "></div>

          <div className=" w-full py-2  ">
            <MaterialExTable
              columns={matcolumns}
              data={emptypeNewData}
              paging={false}
            />
          </div>
        </div>
        <div className="hidden sm:block" aria-hidden="true">
          <div className="py-1"></div>
        </div>
      </div>
    </div>
  );
};

export default EmployeeTypeForm;
